import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrlFinanceComponent} from './components/prl-finance/prl-finance.component';
import {PrlFinanceRoutingModule} from './prl-finance-routing.module';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelActionRow,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle
} from '@angular/material/expansion';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatError, MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {
    MxButtonModule,
    MxFormModule,
    MxGridModule,
    MxInfoTooltipModule,
    MxPreloaderModule,
    MxReportViewModule,
    MxSharedModule
} from 'mx-core';
import {ReactiveFormsModule} from '@angular/forms';
import {PrlLanguageModule} from '../prl-language/prl-language.module';
import {PrlBalanceComponent} from './components/balance/prl-balance/prl-balance.component';
import {PrlPanelComponent} from '../../shared/components/prl-panel/prl-panel.component';
import {PrlPaymentHistoryComponent} from './components/prl-payment-history/prl-payment-history.component';
import {
    PrlPaymentRequestsComponent
} from './components/payment-request/prl-payment-requests/prl-payment-requests.component';
import {
    PrlAddPaymentRequestComponent
} from './components/payment-request/prl-add-payment-request/prl-add-payment-request.component';
import {PrlPaymentAccountComponent} from './components/prl-payment-account/components/accounts/prl-payment-account.component';
import {
    PrlNewPaymentAccountComponent
} from './components/prl-payment-account/components/new-account/prl-new-payment-account.component';
import {
    PrlEditPaymentAccountComponent
} from './components/prl-payment-account/components/edit-account/prl-edit-payment-account.component';

@NgModule({
    declarations: [PrlFinanceComponent,
        PrlPaymentHistoryComponent,
        PrlPaymentRequestsComponent,
        PrlAddPaymentRequestComponent,
        PrlPaymentAccountComponent,
        PrlNewPaymentAccountComponent,
        PrlEditPaymentAccountComponent],
    imports: [
        CommonModule,
        PrlFinanceRoutingModule,
        MatAccordion,
        MatCheckbox,
        MatError,
        MatExpansionPanel,
        MatExpansionPanelActionRow,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        MatFormField,
        MatInput,
        MatLabel,
        MatOption,
        MatSelect,
        MxButtonModule,
        ReactiveFormsModule,
        PrlLanguageModule,
        MxSharedModule,
        PrlBalanceComponent,
        PrlPanelComponent,
        MxInfoTooltipModule,
        MxPreloaderModule,
        MxGridModule,
        MxFormModule,
        MxReportViewModule
    ]
})
export class PrlFinanceModule {

}
